import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class VehiculeService {
    
    get = (callback, queryParams, res) => AxiosService.get(apiUrl('/api/crud/vehicule/get'), callback, res, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/vehicule/get/${id}`), callback);
    getDisponibleActuelle = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/vehicule/disponibilite-vehicule-actuelle'), callback, queryParams);
    getDisponible = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/vehicule/disponibilite-vehicule'), callback, queryParams);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/vehicule/add'), data, callback).then(response => response);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/vehicule/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/vehicule/delete/${id}`), callback);
    //addFile = (formData) => AxiosService.post(apiUrl('/api/filestore/upload/doc'), formData);
    //getFile = (callback) => AxiosService.get(apiUrl(`/api/filestore/download/94613ec2-5611-45b6-965b-693f9273dee2`), callback);

}